import toastr from '@/lib/notifications';
import _ from 'underscore';
import axios from 'axios';
import store from '../state/store';
import {updateLocation, getQueryStringHash} from '../nav';

store.on('leads:show', function(lead_id) {
  const shown_lead = store.get().lead;

  if (!shown_lead || String(shown_lead.id) !== String(lead_id)) {
    store.emit('ui:docked_panels:close_addressed');
  }

  const currentSearch = getQueryStringHash();
  currentSearch.l = lead_id;
  delete currentSearch.e;
  delete currentSearch.t;
  delete currentSearch.lpt;
  updateLocation({search: currentSearch});

  return axios.get(`/api/sales/leads/${lead_id}`)
  .then(function(response) {
    store.get().set({lead: response.data, enquiry: null});

    const backlog_item = _.first(_.select(store.get().backlog.items, item => (item.item_type ==='Sales::Lead') && (item.item_id ===lead_id))
    );

    if (backlog_item) {
      const states = _.select(backlog_item.states, state => state !=='has_messages');

      return backlog_item.set({states});
    }}).catch(error => handleError(error));
});

store.on('leads:create', function(params) {
  store.get().ui.new_lead.set({saving: true})

  axios.post('/api/sales/leads', params)
  .then(function(response) {
    store.get().ui.new_lead.set({open: false, saving: false})
    showMessage('Lead created.')

    // The lead converts straight into an enquiry its creator owns
    store.emit('ui:main_view:set', 'backlog')
    store.emit('enquiries:show', response.data.sales_enquiry_id)
    store.emit('backlog_items:index', {filter: 'my_tasks'})
  })
  .catch(function(error) {
    store.get().ui.new_lead.set({saving: false})
    handleError(error)
  })
});

store.on('lead:settings:update', function(lead_id, settings) {
  if (settings == null) { settings = {}; }
  const params = 
    {settings};
  
  return axios.put(`/api/sales/leads/${lead_id}`, params)
  .then(function(response) {
    store.get().set({lead: response.data});
    
    if (settings.hasOwnProperty('enquirer_name')) {
      store.emit('backlog_items:show', {
        item_id: lead_id,
        item_type: 'Sales::Lead'
      })
    }
  })
  .catch(error => handleError(error));
});

store.on('lead:settings:subjects:add', function(lead_id, subject) {
  const settings = store.get().lead.settings
  
  if (subject.subject_category_name !== settings.subject_category_name) {
    toastr.error('Subject does not belong to correct category');
    return
  }
  
  const subjectNames = _.map(settings.subjects, function(subject) {
    return subject.name
  })

  if (subjectNames.includes(subject.name)) {
    toastr.error('Subject already added')
    return
  } 
  
  const subjects = _.map(settings.subjects, (subject) => {
    return {
      name: subject.name,
      subject_category_name: settings.subject_category_name,
      subject_level_name: settings.subject_level_name,
      syllabus: settings.syllabus
    }
  })

  subjects.push({
    name: subject.name,
    subject_category_name: settings.subject_category_name,
    subject_level_name: settings.subject_level_name,
    syllabus: settings.syllabus
  })

  store.emit('lead:settings:update', lead_id, {subjects})
});

store.on('lead:settings:subjects:update', function(lead_id, subject, update_params) {
  if (update_params == null) { update_params = {}; }
  subject.set(update_params);
  const { subjects } = store.get().lead.settings;
  return store.emit('lead:settings:update', lead_id, {subjects});
});

store.on('lead:settings:subjects:destroy', function(lead_id, subject_name) {
  const { settings } = store.get().lead

  const subjects = _.map(settings.subjects, function(subject) {
    return subject
  })

  const filteredSubjects = _.reject(subjects, function(subject) {
    return subject_name === subject.name
  })
  
  return store.emit('lead:settings:update', lead_id, {subjects: filteredSubjects});
});

store.on('lead:claim', function(lead_id) {
  axios.put(`/api/sales/leads/${lead_id}/claim`)
  .then(response => {
    store.get().set({lead: response.data})
    store.emit('backlog_items:index', {filter: 'my_tasks'})
  }).catch(error => 
    handleError(error)
  )
});

store.on('lead:activate', function(lead_id) {
  axios.put(`/api/sales/leads/${lead_id}/activate`)
  .then(function(response) {
    store.get().set({lead: response.data})
    
    store.emit('backlog_items:show', {
      item_id: lead_id,
      item_type: 'Sales::Lead'
    })
  })
  .catch(error => handleError(error))
});

store.on('lead:deactivate', function(lead_id, reason) {
  const params = {
    deactivation_reason: reason
  }

  axios.put(`/api/sales/leads/${lead_id}/deactivate`, params)
  .then(function(response) {
    store.get().set({lead: response.data})

    store.emit('backlog_items:show', {
      item_id: lead_id,
      item_type: 'Sales::Lead'
    })
  })
  .catch(error => handleError(error))
});

store.on('lead:convert', function(lead_id) {
  axios.put(`/api/sales/leads/${lead_id}/convert`)
  .then(function(response) {
    store.get().set({lead: response.data})

    store.emit('backlog_items:show', {
      item_id: lead_id,
      item_type: 'Sales::Lead'
    })
  })
  .catch(error => 
    handleError(error)
  )
});

store.on('lead:track_call_outcome', function(lead_id, call_outcome) {
  const params = {
    call_outcome: call_outcome
  }

  axios.put(`/api/sales/leads/${lead_id}/track_call_outcome`, params)
  .then(function(response) {
    store.get().set({lead: response.data})
    showMessage('Call outcome added to activity.')
  })
  .catch(error => 
    handleError(error)
  )
});

window.parseObject = function(object, indent = 0) {
  return _.map(_.pairs(object), function(pair) {
    if (_.isObject(pair[1])) {
      return " ".repeat(indent) + `${pair[0]}:\n` + window.parseObject(pair[1], indent + 4)
    }
    else {
      return " ".repeat(indent) + `${pair[0]}: ${pair[1]}`
    }
  }).join("\n")
}

store.on('lead:lookup_ip', function(lead_id) {
  axios.get(`/api/sales/leads/${lead_id}/lookup_ip`)
  .then((response) => {
    alert(parseObject(response.data))
  })
  .catch((error) => {
    handleError(error)
  })
})

store.on('lead:lookup_score', function(lead_id) {
  axios.get(`/api/sales/leads/${lead_id}/lookup_score`)
  .then((response) => {
    alert(parseObject(response.data))
  })
  .catch((error) => {
    handleError(error)
  })
})
